var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Cookies from 'js-cookie';
import { isEuMember } from 'is-eu-member';
import { getCurrentCountry } from '@vp/culture-resolution';
import { Regulations, } from '../types';
import { overrides, DefaultGdprPreferences, AllAllowedPreferences, } from '../constants';
function isGdpr(country) {
    if (!country) {
        return false;
    }
    country = country.toLowerCase();
    return (isEuMember(country) ||
        country === 'ch' ||
        country === 'no' ||
        country === 'gb');
}
function isConsentRequired() {
    var country;
    try {
        country = getCurrentCountry();
    }
    catch (_a) {
        return true;
    }
    return isGdpr(country);
}
export function getRegulations() {
    var country;
    try {
        country = getCurrentCountry();
    }
    catch (_a) {
        return Regulations.GDPR;
    }
    if (!country) {
        return Regulations.None;
    }
    country = country.toLowerCase();
    if (country === 'us') {
        return Regulations.CCPA;
    }
    if (isGdpr(country)) {
        return Regulations.GDPR;
    }
    return Regulations.None;
}
function getConsentCookie() {
    var cookieValue = Cookies.get('tracking-preferences');
    if (!cookieValue) {
        return {};
    }
    return JSON.parse(cookieValue);
}
function getDataSale(cookie) {
    var _a, _b;
    if (cookie.version === 4) {
        return (_b = (_a = cookie.custom) === null || _a === void 0 ? void 0 : _a.datasale) !== null && _b !== void 0 ? _b : true;
    }
    if (cookie.destinations &&
        cookie.destinations.All === true &&
        cookie.destinations['Facebook Pixel'] === false) {
        return false;
    }
    return true;
}
export function applyOverrides(categories, overridesObj) {
    if (overridesObj === void 0) { overridesObj = overrides; }
    var country;
    try {
        country = getCurrentCountry();
    }
    catch (_a) {
        return categories;
    }
    if (overridesObj && Object.keys(overridesObj).includes(country)) {
        var overridenCategories_1 = Object(categories);
        Object.keys(overridesObj[country]).forEach(function (category) {
            overridenCategories_1[category] = Object(overridesObj[country])[category];
        });
        return overridenCategories_1;
    }
    return categories;
}
export function getCookieConsent() {
    var regulations = getRegulations();
    var cookie = getConsentCookie();
    if (regulations === Regulations.None) {
        return {
            hasConsent: false,
            categories: AllAllowedPreferences,
        };
    }
    if (regulations === Regulations.CCPA) {
        return {
            hasConsent: false,
            categories: __assign(__assign({}, AllAllowedPreferences), { dataSale: getDataSale(cookie) }),
        };
    }
    // GDPR
    if (cookie.custom) {
        var _a = cookie.custom, functional = _a.functional, advertising = _a.advertising, sessionreplay = _a.sessionreplay;
        var categories = {
            hasConsent: cookie.consent !== false,
            categories: {
                functional: functional !== null && functional !== void 0 ? functional : true,
                advertising: advertising !== null && advertising !== void 0 ? advertising : false,
                sessionReplay: sessionreplay !== null && sessionreplay !== void 0 ? sessionreplay : false,
                dataSale: getDataSale(cookie),
            },
        };
        return categories;
    }
    return {
        hasConsent: false,
        categories: applyOverrides(DefaultGdprPreferences),
    };
}
export function isCookieConsentPending() {
    var cookie = getConsentCookie();
    if (cookie && cookie.custom && cookie.consent !== false) {
        return false;
    }
    return isConsentRequired();
}
//# sourceMappingURL=data:application/json;base64,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